class EscapeMobileDock extends HTMLElement {
  connectedCallback() {
    this.setHeightVar();
    requestAnimationFrame(() => this.setHeightVar());
    window.addEventListener('resize', this.setHeightVar);

    this.querySelectorAll('[data-action]').forEach((btn) => {
      btn.addEventListener('click', (event) => {
        const action = event.currentTarget.getAttribute('data-action');
        if (action === 'cart') this.openCart();
        if (action === 'search') this.openSearch();
        if (action === 'account') this.openAccount();
      });
    });
  }

  disconnectedCallback() {
    window.removeEventListener('resize', this.setHeightVar);
  }

  setHeightVar = () => {
    document.documentElement.style.setProperty('--es-dock-height', `${this.offsetHeight || 72}px`);
  };

  openCart() {
    if (typeof window.escapeOpenGokwikCart === 'function') {
      window.escapeOpenGokwikCart();
      return;
    }
    const drawer = document.querySelector('cart-drawer-component');
    if (drawer && typeof drawer.open === 'function') {
      drawer.open();
    }
  }

  openAccount() {
    if (typeof window.handleKpAndShopifyLogin === 'function') {
      window.handleKpAndShopifyLogin();
      return;
    }
    if (typeof window.openIframe === 'function') {
      window.openIframe('kp_sso_token');
      return;
    }
    document.querySelector('header-actions [data-kp-slot]')?.click();
  }

  openSearch() {
    // Horizon: <dialog-component id="search-modal"> exposes showDialog()
    const modal = document.getElementById('search-modal');
    if (modal && typeof modal.showDialog === 'function') {
      modal.showDialog();
      return;
    }
    const searchTrigger = document.querySelector(
      '.search-action button, [data-testid="search-modal-trigger"], button[aria-controls*="search"]'
    );
    if (searchTrigger) {
      searchTrigger.click();
      return;
    }
    window.location.href = window.Shopify?.routes?.root
      ? `${window.Shopify.routes.root}search`
      : '/search';
  }
}

if (!customElements.get('escape-mobile-dock')) {
  customElements.define('escape-mobile-dock', EscapeMobileDock);
}
